import { render, staticRenderFns } from "./APage.vue?vue&type=template&id=38de07c5&scoped=true&"
import script from "./APage.vue?vue&type=script&lang=js&"
export * from "./APage.vue?vue&type=script&lang=js&"
import style0 from "./APage.vue?vue&type=style&index=0&id=38de07c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de07c5",
  null
  
)

export default component.exports